import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    Button,
    Classes,
    FormGroup,
    MenuItem,
    Spinner,
} from '@blueprintjs/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark'

import InputSelect from '../InputSelect'
import { UserDataContext } from 'src/HOCs/withAuth'

import styles from './userMenu.module.scss'

class ImpersonateUserMenu extends Component {
    static propTypes = {
        users: PropTypes.arrayOf(PropTypes.object).isRequired,
        loadingUsers: PropTypes.bool.isRequired,
        onLoadUsers: PropTypes.func.isRequired,
        onLoadOrganizations: PropTypes.func.isRequired,
        onUserChange: PropTypes.func.isRequired,
    }

    static contextType = UserDataContext

    state = {
        loadingFilteredUser: false,
    }

    componentDidMount() {
        const { onLoadUsers } = this.props

        onLoadUsers(this.context.data)
    }

    userData() {
        const { users } = this.props

        return users.map((user) => ({
            value: user.username,
            label: `${user.first_name} ${user.last_name}`,
            id: user.id,
        }))
    }

    handleQueryChange = (searchTerm) => {
        const { onLoadUsers } = this.props

        this.setState({ loadingFilteredUser: true })
        onLoadUsers(this.context.data, searchTerm).finally(() =>
            this.setState({ loadingFilteredUser: false })
        )
    }

    renderUserItem = (item, { handleClick, modifiers }) => {
        return (
            <MenuItem
                active={modifiers.active}
                key={item.id}
                onClick={handleClick}
                text={item.label}
            />
        )
    }

    renderUserImpersonate() {
        const { loadingFilteredUser } = this.state
        const {
            loadingUsers,
            onLoadUsers,
            onUserChange,
            onLoadOrganizations,
        } = this.props

        if (this.context.impersonatedUser) {
            return (
                <>
                    <p className={styles.impersonateText}>Impersonate</p>
                    <div className={styles.activeUser}>
                        <p>
                            You are impersonating{' '}
                            {this.context.impersonatedUser.label}.
                        </p>
                        <Button
                            onClick={() =>
                                onUserChange(null, () => {
                                    onLoadUsers(this.context.data)
                                    onLoadOrganizations(
                                        this.context.data.username
                                    )
                                })
                            }
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </Button>
                    </div>
                </>
            )
        }

        return loadingUsers ? (
            <div className={styles.inputPlaceholder}>
                <p className={Classes.SKELETON} />
                <div className={Classes.SKELETON} />
            </div>
        ) : this.context.data.is_global_admin ? (
            <>
                <FormGroup
                    label="Impersonate"
                    labelFor="impersonate"
                    className={styles.customInput}
                >
                    <InputSelect
                        inputProps={{
                            id: 'impersonate',
                        }}
                        additionalRightElement={
                            loadingFilteredUser ? (
                                <Spinner
                                    intent="primary"
                                    size={16}
                                    className={styles.loadFilteredSpinner}
                                />
                            ) : null
                        }
                        selectedItem={this.context.impersonatedUser}
                        items={this.userData()}
                        itemRenderer={this.renderUserItem}
                        inputValueRenderer={(user) => user.label}
                        onItemSelect={onUserChange}
                        onQueryChange={this.handleQueryChange}
                        noResults={
                            <MenuItem disabled={true} text="No results" />
                        }
                        popoverProps={{
                            targetClassName: 'full-width',
                            minimal: true,
                        }}
                        minimal={true}
                    />
                </FormGroup>
            </>
        ) : null
    }

    render() {
        return (
            <>
                {!this.context.data.is_local_user
                    ? this.renderUserImpersonate()
                    : null}
            </>
        )
    }
}

export default ImpersonateUserMenu
